export const FETCH_SUMMARY_REPORT_TREE = "app/summaryReportTree/FETCH_SUMMARY_REPORT_TREE";
export const FETCH_SUMMARY_REPORT_TREE_START = "app/summaryReportTree/FETCH_SUMMARY_REPORT_TREE_START";
export const FETCH_SUMMARY_REPORT_TREE_ERROR = "app/summaryReportTree/FETCH_SUMMARY_REPORT_TREE_ERROR";
export const CLEAR = "app/summaryReportTree/CLEAR";

export default {
  FETCH_SUMMARY_REPORT_TREE,
  FETCH_SUMMARY_REPORT_TREE_START,
  FETCH_SUMMARY_REPORT_TREE_ERROR,
  CLEAR,
};



// WEBPACK FOOTER //
// ./src/redux/summaryReportTree/types.js